import React from 'react'
import { render } from 'react-dom'
import { createBrowserHistory } from 'history'
import { Provider } from 'react-redux'
import { Route, Redirect } from 'react-router' 
import { ConnectedRouter, connectRouter, routerMiddleware } from 'connected-react-router'
import { applyMiddleware, createStore, combineReducers, compose } from 'redux'
import { reactReduxFirebase, firebaseReducer } from 'react-redux-firebase'

import firebase from 'firebase/app'
import 'firebase/database'

import uiReducer from './reducers/ui'

import App from './components/App'
import ClaimYourProfile from './components/claim-your-profile'
import PrivacyPolicy from './components/privacy-policy'
import Imprint from './components/imprint'
import { scrollTo } from './utils'

firebase.initializeApp({
    apiKey: "AIzaSyDu9Xj5xmCh4GwIR8I9fcu25NouXXm6VO8",
    authDomain: "delight-directory.firebaseapp.com",
    databaseURL: "https://delight-directory.firebaseio.com",
    projectId: "delight-directory",
    storageBucket: "delight-directory.appspot.com",
    messagingSenderId: "1024361332963"
  })


const history = createBrowserHistory()

const rootReducer = combineReducers({
    firebase: firebaseReducer,
    uiReducer
})

const store = createStore(
    connectRouter(history)(rootReducer),
    {},
    compose(
        reactReduxFirebase(firebase),
        applyMiddleware(
            routerMiddleware(history)
        )
        // ,window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__()
    )
)

history.listen(location => {
    scrollTo(0, 200, 'easeOutQuad')
})

render((
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <Route exact path="/" render={() => <Redirect to="/all/anywhere/1/" />} />
                <Route path="/:what/:where/:pageNumber/:exact?" component={App} />
            <Route path="/claim-profile" component={ClaimYourProfile} />
            <Route path="/privacy-policy" component={PrivacyPolicy}></Route>
            <Route path="/imprint" component={Imprint}></Route>
            </div>
        </ConnectedRouter>
    </Provider>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js